function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "app-icon-b",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#D2E3E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#ABB3B3"
})), /*#__PURE__*/React.createElement("path", {
  id: "app-icon-a",
  d: "M58.84375,4 C69.25,4 76,10.75 76,21.15625 L76,58.84375 C76,69.25 69.25,76 58.84375,76 L21.15625,76 C10.75,76 4,69.25 4,58.84375 L4,21.15625 C4,10.75 10.75,4 21.15625,4 L58.84375,4 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "app-icon-d",
  points: "24.798 42.102 24.798 .052 .043 .052 .043 42.102 24.798 42.102"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "app-icon-c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#app-icon-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#app-icon-b)",
  xlinkHref: "#app-icon-a"
}), /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  x: 4,
  y: 4,
  fill: "#CE262F",
  mask: "url(#app-icon-c)"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#app-icon-c)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.824 16)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.216 5.864)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "app-icon-e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#app-icon-d"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M24.7985766,40.954138 C16.5462969,36.9788844 8.29482251,44.9293916 0.0433480972,40.954138 C0.0425428396,27.7024743 0.0425428396,14.4508105 0.0433480972,1.19914682 C8.29482251,5.1744004 16.5462969,-2.77610675 24.7985766,1.19914682 L24.7985766,40.954138 Z",
  mask: "url(#app-icon-e)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#CE262F",
  d: "M29.6255874,25.4985876 C29.9106486,25.431474 30.196515,25.3627235 30.4815762,25.293973 C31.5477372,25.0377954 31.6475892,24.3527455 31.6483944,23.5514745 C31.6475892,22.1109873 31.6475892,20.6713186 31.6483944,19.2308314 C31.6459787,18.2904225 31.5485425,17.7207752 30.4815762,17.9769528 C30.196515,18.0457033 29.9106486,18.1144538 29.6255874,18.1815675 L29.6255874,25.4985876 Z M29.6255874,29.714468 L29.6255874,40.0974343 C28.1052611,40.4559191 26.58574,40.7816657 25.066219,40.9248959 L25.066219,15.0026741 C27.2267251,14.7988779 29.3856206,14.2275938 31.5453215,13.7152387 C35.4202209,12.8034758 36.2423889,14.8144286 36.2415837,17.9818635 L36.2415837,23.1725282 C36.2431942,26.3939814 34.973303,28.440128 31.7852882,29.1980206 C31.065388,29.3674416 30.3454877,29.5442287 29.6255874,29.714468 L29.6255874,29.714468 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E7E7E7",
  d: "M25.0907793,40.9476491 C25.0907793,40.9476491 24.7074767,43.1566689 18.258974,46.8176344 L18.258974,25.3404614 L25.0907793,40.9476491 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.0680711,40.9026339 C16.7127184,36.9273803 8.35656053,44.8778874 0.00040262879,40.9026339 L0.00040262879,1.14764269 C8.35656053,5.12289627 16.7127184,-2.82761088 25.0680711,1.14764269 L25.0680711,40.9026339 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CE262F",
  d: "M11.4584933,18.8286408 C11.7556333,18.7598903 12.0527733,18.6886844 12.3499134,18.618297 C13.2775701,18.3981316 13.6181941,17.9708962 13.6181941,16.7513928 L13.6181941,13.2320207 C13.6173888,12.1172801 13.4120481,11.8152688 12.4868072,12.0354342 C12.1445727,12.1172801 11.801533,12.1991259 11.4584933,12.2785164 L11.4584933,18.8286408 Z M11.4584933,34.1935648 C9.9389722,34.5471389 8.41945115,34.8671562 6.89912484,35.009568 L6.89912484,9.0873462 C9.29879242,8.86227008 11.6992653,8.19604475 14.0981276,7.65176976 C16.875461,7.01091665 18.2798302,8.47923144 18.2798302,11.258717 L18.2798302,15.4050284 C18.2814407,17.558393 17.1122067,18.6166601 16.2578284,19.1609351 C16.9769234,19.3017099 18.2137991,20.0358673 18.2121886,21.960882 L18.2121886,30.7756815 C18.2105781,31.8912406 18.4183345,32.3602174 18.5882439,32.6614102 L18.5882439,32.8357419 C17.0687228,32.9445969 15.550007,33.2433343 14.0296807,33.5895423 C13.7913245,33.3644662 13.6198046,32.8480188 13.6181941,31.6980844 L13.6181941,24.1371635 C13.6165836,22.9176602 13.3452118,22.6672118 12.4183603,22.8873772 C12.098673,22.9634939 11.7781805,23.0396105 11.4584933,23.1140902 L11.4584933,34.1935648 Z"
}))));

function SvgRadiopublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiopublic);
export default __webpack_public_path__ + "static/media/radiopublic.423addf3.svg";
export { ForwardRef as ReactComponent };